import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-align-items-center is-justify-content-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometer = _resolveComponent("Cronometer")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Cronometer, { timeInSeconds: _ctx.timeInSeconds }, null, 8, ["timeInSeconds"]),
    _createVNode(_component_AppButton, {
      isDisabled: _ctx.isTimeRunning,
      btnIcon: 'play',
      btnText: 'Start',
      onBtnClicked: _ctx.start
    }, null, 8, ["isDisabled", "onBtnClicked"]),
    _createVNode(_component_AppButton, {
      isDisabled: !_ctx.isTimeRunning,
      btnIcon: 'stop',
      btnText: 'Stop',
      onBtnClicked: _ctx.stop
    }, null, 8, ["isDisabled", "onBtnClicked"])
  ]))
}